import { Controller } from "stimulus"

export default class extends Controller {

    static targets = [ "navbar", "shared_with", "shared_public"]

    static values = {
        page: String,
        filter: String
    }

    connect() {
        if(this.hasNavbarTarget) {
            let navLink;
            if(this.filterValue == "shared") {
                navLink = this.navbarTarget.querySelector(`a[data-page="shared"]`);
            } else if(this.filterValue == "projects") {
                navLink = this.navbarTarget.querySelector(`a[data-page="projects"]`);
            } else {
                navLink = this.navbarTarget.querySelector(`a[data-page="personal"]`);
            }

            if(navLink) {
                navLink.classList.add("text-white")
            }
        }
    }

    toggleShareWith() {
      switch(event.target.value) {
        case "shared":
          this.shared_publicTarget.classList.add('d-none')
          this.shared_withTarget.classList.remove('d-none')
          break;
        case "public":
          this.shared_withTarget.classList.add('d-none')
          this.shared_publicTarget.classList.remove('d-none')
          break;
        default:
          this.shared_publicTarget.classList.add('d-none')
          this.shared_withTarget.classList.add('d-none')
      }
    }
}
